import styled from 'styled-components';
import { Divider, Button, Tabs } from 'antd';


export const DividerS = styled(Divider)`
  width: calc(100% + 48px);
  margin: 20px -24px 13px -24px;
`;

export const CopyToClipboardWr = styled.div`
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-end;
  align-items: center;
`;

export const CopyButton = styled(Button)`
  margin-right: 10px;
  border: 1px solid ${props => props.theme.colors.borderOrange};
  color: ${props => props.theme.colors.fontTangerine};
  
  &:hover,
  &:focus {
  border: 1px solid ${props => props.theme.colors.borderOrange};
  background-color: ${props => props.theme.colors.borderOrange};
  color: ${props => props.theme.colors.white};
  }
`;

export const InvitationLink = styled.div`
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const TabsS = styled(Tabs)`
  &.ant-tabs {
    max-width: 565px;
    margin: 0 auto;

    .ant-tabs-bar {
      border-bottom: none;
    }

    .ant-tabs-nav div.ant-tabs-tab {
      transition: none;
      padding-left: 0;
      padding-right: 0;
      padding-bottom: 3px;
      font-weight: 400;
      color: ${props => props.theme.colors.fontSilverPrimary};
      border-bottom: 1px solid transparent;
      transition: border-color 0.2s ease-in-out;

      &:hover {
        border-color: ${props => props.theme.colors.borderSilverDark};
        padding-bottom: 2px;
      }
    }

    .ant-tabs-nav div.ant-tabs-tab-active {
      color: ${props => props.theme.colors.tangerinePrimary};
    }

    .ant-tabs-ink-bar {
      background-color: ${props => props.theme.colors.borderOrange};
      height: 1px;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/modals/manage-users-modal/styled-components.js